import { React, useContext, useState, useRef, useMemo, useEffect } from 'react'
import { MyContextProvider } from "../../App";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import { GlobalLoading, showLoading } from 'react-global-loading';
import messages from '../../assets/Messages.json'
import { API_URL } from '../../Constant';
import titlesData from '../../titles.json';
import { useNavigate } from 'react-router-dom';
// import { getToken } from '../../utils/authStorage';
import { getToken } from '../../hooks/useAuthStorage';

function ChangePassword({ userId }) {

  const navigate = useNavigate();
  const formRef = useRef();
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    email: '',
    contactNo: ''
  });
  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    newPassword: false,
    confirmNewPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const loginContext = useContext(MyContextProvider);
  const token = loginContext?.token || getToken();
  const loginCallFromChild = loginContext?.loginCallFromChild;
  const storedLanguage = localStorage.getItem('language');
  const axiosConfig = useMemo(() => ({
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  }), [token]);

  // Mount par state explicitly empty — koi default / purana value na rahe
  useEffect(() => {
    setFormData({
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      email: '',
      contactNo: '',
    });
  }, []);

  // const value = useContext(MyContextProvider);
  // console.log('token', value)

  // Handle key press for contactNo field - only allow numbers
  const handleKeyPress = (e) => {
    if (e.target.name === 'contactNo') {
      // Allow: numbers (0-9), backspace, delete, tab, escape, enter, arrow keys, and other control keys
      const key = e.key;
      const isNumber = /[0-9]/.test(key);
      const isControlKey = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End'].includes(key) ||
                          key.startsWith('Arrow') || key === 'Meta' || key === 'Control' || key === 'Alt';
      
      if (!isNumber && !isControlKey) {
        e.preventDefault();
        const errorMessage = storedLanguage === 'hi'
          ? 'कृपया केवल संख्याएं दर्ज करें।'
          : 'Please enter numbers only.';
        toast.error(errorMessage, messages.COLOR_RED);
      }
    }
  };

  // Handle paste event for contactNo field - only allow numbers
  const handlePaste = (e) => {
    if (e.target.name === 'contactNo') {
      e.preventDefault();
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      const numericValue = pastedText.replace(/\D/g, ''); // Remove non-numeric characters
      
      if (pastedText !== numericValue) {
        const errorMessage = storedLanguage === 'hi'
          ? 'कृपया केवल संख्याएं दर्ज करें।'
          : 'Please enter numbers only.';
        toast.error(errorMessage, messages.COLOR_RED);
      }
      
      // Update form data with only numeric values
      setFormData({
        ...formData,
        contactNo: numericValue,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // For contactNo field, only allow numbers
    if (name === 'contactNo') {
      const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const validateForm = () => {

    if (!formData.oldPassword.trim()) {
      toast.error(messages.OLD_PASSWORD_MSG, messages.COLOR_RED);
      return;
    }
    if (!formData.newPassword.trim()) {
      toast.error(messages.NEW_PASSWORD_MSG, messages.COLOR_RED);
      return;
    }

    const password = formData.newPassword;
    if (password.length < 8 || password.length > 30) {
      toast.error(messages.PASSWORD_MIN_AND_MAX_LENGTH_MSG, messages.COLOR_RED);
      return;
    }
    if (!/[A-Z]/.test(password)) {
      toast.error(messages.PASSWORD_SPECIAL_CHARACTER_MSG, messages.COLOR_RED);
      return;
    }
    if (!/[a-z]/.test(password)) {
      toast.error(messages.PASSWORD_SPECIAL_CHARACTER_MSG, messages.COLOR_RED);
      return;
    }
    if (!/[0-9]/.test(password)) {
      toast.error(messages.PASSWORD_SPECIAL_CHARACTER_MSG, messages.COLOR_RED);
      return;
    }
    if (!/[!@#.$%^&*()\-_=+{}\[\]:;"'<>,.?/\\|]/.test(password)) {
      toast.error(messages.PASSWORD_SPECIAL_CHARACTER_MSG, messages.COLOR_RED);
      return;
    }
    if (password.includes(' ')) {
      toast.error(
        storedLanguage === 'hi'
          ? 'पासवर्ड में स्पेस नहीं होना चाहिए।'
          : 'Password should not contain spaces.',
        messages.COLOR_RED
      );
      return;
    }
    if (formData.oldPassword.trim() && formData.oldPassword === formData.newPassword) {
      toast.error(
        storedLanguage === 'hi'
          ? 'नया पासवर्ड पुराना पासवर्ड जैसा नहीं हो सकता।'
          : 'New password cannot be the same as old password.',
        messages.COLOR_RED
      );
      return;
    }
    if (!formData.confirmNewPassword.trim()) {
      toast.error(messages.CONFIRM_PASSWORD_MSG, messages.COLOR_RED);
      return;
    }
    if (formData.newPassword !== formData.confirmNewPassword) {
      toast.error(messages.PASSWORD_MATCH_MSG, messages.COLOR_RED);
      return;
    }
    
    // Email validation (if email is provided)
    if (formData.email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        toast.error('Please Enter Valid Email Id', messages.COLOR_RED);
        return;
      }
    }
    
    // contactNo validation (if contactNo is provided)
    if (formData.contactNo.trim()) {
      const contactNoLength = formData.contactNo.trim().length;
      if ((contactNoLength !== 10 && contactNoLength !== 11) || !/^\d{10,11}$/.test(formData.contactNo.trim())) {
        toast.error('Please Enter Valid Contact Number', messages.COLOR_RED);
        return;
      }
    }
    
    return true;

  };

  const handleReset = () => {
    // Reset form fields
    setFormData({
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      email: '',
      contactNo: ''
    });
    // Reset form using the formRef
    formRef.current.reset();
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      // Perform form submission logic
      showLoading(true);
      try {
        // Example Axios call to change the password
        const requestData = {
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
          confirmNewPassword: formData.confirmNewPassword,
        };
        
        // Add email and contactNo only if they have values (optional fields)
        if (formData.email.trim()) {
          requestData.email = formData.email.trim();
        }
        if (formData.contactNo.trim()) {
          requestData.contactNo = formData.contactNo.trim();
        }
        
        const response = await axios.post(`${API_URL}api/changePwd`, requestData, axiosConfig);

        if (response?.data?.status === false) {
          const failureMessage =
            response?.data?.message ||
            (storedLanguage === 'hi'
              ? 'पासवर्ड बदलने में असफल।'
              : 'Failed to change password.');
          toast.error(failureMessage, messages.COLOR_RED);
        } else if (response?.data?.status === true && response?.status === 200) {
          // Extract new token from response if available
          const newToken = response?.data?.data?.token || response?.data?.token;
          
          // Update token if new token is received
          if (newToken && loginCallFromChild) {
            loginCallFromChild(newToken);
          }
          
          const successMessage =
            response?.data?.message ||
            (storedLanguage === 'hi'
              ? 'पासवर्ड सफलतापूर्वक बदल दिया गया।'
              : 'Password changed successfully.');
          toast.success(successMessage, messages.COLOR_RED);
          handleReset();
          // Redirect to home page after successful password change
          setTimeout(() => {
            navigate('/');
          }, 1500); // Wait 1.5 seconds to show success message
        } else {
          // Extract new token from response if available
          const newToken = response?.data?.data?.token || response?.data?.token;
          
          // Update token if new token is received
          if (newToken && loginCallFromChild) {
            loginCallFromChild(newToken);
          }
          
          const successMessage =
            response?.data?.message ||
            (storedLanguage === 'hi'
              ? 'पासवर्ड सफलतापूर्वक बदल दिया गया।'
              : 'Password changed successfully.');
          toast.success(successMessage, messages.COLOR_RED);
          handleReset();
          // Redirect to home page after successful password change
          setTimeout(() => {
            navigate('/');
          }, 1500); // Wait 1.5 seconds to show success message
        }

      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          error?.message ||
          (storedLanguage === 'hi'
            ? 'पासवर्ड बदलने में असफल।'
            : 'Failed to change password.');
        toast.error(errorMessage, messages.COLOR_RED);
        console.error('Error changing password:', error);
      } finally {
        showLoading(false);
      }

    } else {
      console.log('Form has validation errors.');
    }
  }

  return (
    <>
      {/* Page Content Open */}
      <div className="container-fluid py-3">
        <GlobalLoading />
        <ToastContainer />
        <form ref={formRef} onSubmit={handleSubmit} noValidate autoComplete="off">
          <div className="card mx-3 mb-3">
            <div className="card-body">
              <h4 className="page_heading">{storedLanguage === 'hi' ? titlesData.hi.ChangePassword : titlesData.en.ChangePassword}</h4>
              <div className="row">
                <div className="col-12 mb-2">
                  <h6>{storedLanguage === 'hi' ? titlesData.hi.USER_ID : titlesData.en.USER_ID}: <strong>{userId}</strong></h6>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.OLD_PASSWORD : titlesData.en.OLD_PASSWORD} <span style={{ color: 'red' }}>*</span></label>
                  <div className="position-relative">
                    <input
                      type={showPasswords.oldPassword ? 'text' : 'password'}
                      onChange={handleChange}
                      name="oldPassword"
                      className="form-control"
                      maxLength={30}
                      value={formData.oldPassword}
                      autoComplete="off"
                      spellCheck={false}
                    />
                    <span
                      className="eye_password"
                      onClick={() => togglePasswordVisibility('oldPassword')}
                      role="button"
                      tabIndex={0}
                    >
                      {showPasswords.oldPassword ? (
                        <i className="fa fa-eye" />
                      ) : (
                        <i className="fa fa-eye-slash" />
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.NEW_PASSWORD : titlesData.en.NEW_PASSWORD} <span style={{ color: 'red' }}>*</span></label>
                  <div className="position-relative">
                    <input
                      type={showPasswords.newPassword ? 'text' : 'password'}
                      onChange={handleChange}
                      name="newPassword"
                      className="form-control"
                      maxLength={30}
                      value={formData.newPassword}
                      autoComplete="new-password"
                      spellCheck={false}
                    />
                    <span
                      className="eye_password"
                      onClick={() => togglePasswordVisibility('newPassword')}
                      role="button"
                      tabIndex={0}
                    >
                      {showPasswords.newPassword ? (
                        <i className="fa fa-eye" />
                      ) : (
                        <i className="fa fa-eye-slash" />
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.CONFIRM_NEW_PASSWORD : titlesData.en.CONFIRM_NEW_PASSWORD} <span style={{ color: 'red' }}>*</span></label>
                  <div className="position-relative">
                    <input
                      type={showPasswords.confirmNewPassword ? 'text' : 'password'}
                      onChange={handleChange}
                      name="confirmNewPassword"
                      className="form-control"
                      maxLength={30}
                      value={formData.confirmNewPassword}
                      autoComplete="new-password"
                      spellCheck={false}
                    />
                    <span
                      className="eye_password"
                      onClick={() => togglePasswordVisibility('confirmNewPassword')}
                      role="button"
                      tabIndex={0}
                    >
                      {showPasswords.confirmNewPassword ? (
                        <i className="fa fa-eye" />
                      ) : (
                        <i className="fa fa-eye-slash" />
                      )}
                    </span>
                  </div>
                  <small className="text-danger d-none">Error message</small>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.EMAIL : titlesData.en.EMAIL}</label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="email"
                    className="form-control"
                    placeholder={storedLanguage === 'hi' ? 'ईमेल दर्ज करें' : 'Enter email'}
                    maxLength={50}
                    value={formData.email}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <label>{storedLanguage === 'hi' ? 'मोबाइल / संपर्क नंबर' : 'Mobile / Contact No'}</label>
                  <input
                    type="tel"
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    onPaste={handlePaste}
                    name="contactNo"
                    className="form-control"
                    placeholder={storedLanguage === 'hi' ? 'मोबाइल नंबर दर्ज करें' : 'Enter mobile number'}
                    minLength={10}
                    maxLength={11}
                    pattern="[0-9]{10,11}"
                    value={formData.contactNo}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="row">
                    <div className="col-6 mb-3">
                      <button type="submit" className="btn w-100 btn_orange">Update</button>
                    </div>

                    <div className="col-6 mb-3 font14 text-end"><button type="reset"
                      className="btn w-100 btn_gray" onClick={handleReset}>Reset</button></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </>
  )
}

export default ChangePassword